(ns metabase.lib.common
  (:refer-clojure :exclude [mapv every? #?@(:clj [for empty?])])
  (:require
   [metabase.lib.dispatch :as lib.dispatch]
   [metabase.lib.hierarchy :as lib.hierarchy]
   [metabase.lib.options :as lib.options]
   [metabase.lib.ref :as lib.ref]
   [metabase.lib.schema.common :as schema.common]
   [metabase.lib.schema.literal :as lib.schema.literal]
   [metabase.lib.schema.mbql-clause :as lib.schema.mbql-clause]
   [metabase.lib.schema.metadata :as lib.schema.metadata]
   [metabase.util :as u]
   [metabase.util.malli :as mu]
   [metabase.util.malli.registry :as mr]
   [metabase.util.performance :refer [mapv #?@(:clj [every? for empty?])]])
  #?(:cljs (:require-macros [metabase.lib.common])))

(comment lib.options/keep-me
         mu/keep-me)

(mu/defn external-op :- [:maybe ::schema.common/external-op]
  "Convert the internal operator `clause` to the external format."
  [[operator options :as clause] :- [:maybe ::lib.schema.mbql-clause/clause]]
  (when clause
    {:lib/type :lib/external-op
     :operator (cond-> operator
                 (keyword? operator) name)
     :options  options
     :args     (subvec clause 2)}))

(defmulti ->op-arg
  "Ensures that clause arguments are properly unwrapped"
  {:arglists '([x])}
  lib.dispatch/dispatch-value
  :hierarchy lib.hierarchy/hierarchy)

(defmethod ->op-arg :default
  [x]
  (if (and (vector? x)
           (keyword? (first x)))
    ;; MBQL clause
    (mapv ->op-arg x)
    ;; Something else - just return it
    x))

(defmethod ->op-arg :dispatch-type/sequential
  [xs]
  (mapv ->op-arg xs))

(defmethod ->op-arg :dispatch-type/regex
  [regex]
  (u/regex->str regex))

(defmethod ->op-arg :metadata/column
  [field-metadata]
  (lib.ref/ref field-metadata))

(defmethod ->op-arg :metadata/metric
  [metric-def]
  (lib.ref/ref metric-def))

(defmethod ->op-arg :metadata/segment
  [segment-def]
  (lib.ref/ref segment-def))

(defmethod ->op-arg :metadata/measure
  [measure-def]
  (lib.ref/ref measure-def))

(defmethod ->op-arg :lib/external-op
  [{:keys [operator options args] :or {options {}}}]
  (->op-arg (-> (lib.options/ensure-uuid (into [(keyword operator) options]
                                               (map ->op-arg)
                                               args))
                ((#?(:clj requiring-resolve :cljs resolve) 'metabase.lib.normalize/normalize)))))

(defn defop-create
  "Impl for [[defop]]."
  [op-name args]
  (into [op-name {:lib/uuid (str (random-uuid))}]
        (map ->op-arg)
        args))

(defn- regex?
  "Whether `x` is a regex pattern object."
  [x]
  #?(:clj  (instance? java.util.regex.Pattern x)
     :cljs (regexp? x)))

(mr/def ::op-arg
  "A value `->op-arg` can turn into a clause argument: a literal, a metadata ref, an already-built clause, a clause
  whose arguments are still any of these, an external-op map, a regex, or a (possibly nested) sequence of these."
  [:or
   :string
   :boolean
   :keyword
   number?
   nil?
   [:fn regex?]
   ::lib.schema.literal/literal
   ::lib.schema.metadata/column
   ::lib.schema.metadata/metric
   ::lib.schema.metadata/segment
   ::lib.schema.metadata/measure
   ::schema.common/external-op
   ::lib.schema.mbql-clause/clause
   [:and vector? [:cat :keyword [:? ::schema.common/options] [:* [:schema [:ref ::op-arg]]]]]
   [:sequential [:ref ::op-arg]]])

#?(:clj
   (defn- typed-argvec
     "Add `:- ::op-arg` to each positional arg symbol in `argvec`, and `:- [:* ::op-arg]` to a trailing `& more`."
     [argvec]
     (loop [args argvec, out [], variadic? false]
       (if (empty? args)
         out
         (let [arg (first args)]
           (cond
             (= arg '&) (recur (rest args) (conj out '&) true)
             variadic?  (recur (rest args) (conj out arg :- [:* ::op-arg]) false)
             :else      (recur (rest args) (conj out arg :- ::op-arg) false)))))))

#?(:clj
   (defmacro defop
     "Defines a clause creating function with given args.
      Calling the clause without query and stage produces a fn that can be resolved later."
     [op-name & argvecs]
     {:pre [(symbol? op-name)
            (every? vector? argvecs) (every? #(every? symbol? %) argvecs)
            (every? #(not-any? #{'query 'stage-number} %) argvecs)]}
     `(mu/defn ~op-name :- ~(keyword "mbql.clause" (name op-name))
        ~(format "Create a standalone clause of type `%s`." (name op-name))
        ~@(for [argvec argvecs
                :let [arglist-expr (if (contains? (set argvec) '&)
                                     (cons `list* (remove #{'&} argvec))
                                     argvec)]]
            `([~@(typed-argvec argvec)]
              (defop-create ~(keyword op-name) ~arglist-expr))))))
